import { createTheme } from '@mui/material/styles';

// declare module '@mui/material/styles' {
//   interface Palette {
//   }
//   interface PaletteOptions {
//   }
// }

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      light: '#EBFDFF',
      main: '#00ACC1',
      dark: '#007E8F'
    },
    secondary: {
      light: '#FFF0C2',
      main: '#FFE082',
      dark: '#B29C5B'
    },
    text: {
      primary: '#212120',
      secondary: '#6B6B6B'
    },
    background: {
      default: '#FFFFFF'
    },
    divider: '#E0E0E0'
  },
  typography: {
    fontFamily: '"Open Sans Variable"',
    subtitle2: {
      fontWeight: 500,
      fontSize: '14px',
      lineHeight: '157%',
      letterSpacing: '0.1px'
    },
    h5: {
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '133%',
      letterSpacing: '0px'
    },
    h6: {
      fontWeight: 500,
      fontSize: '20px',
      lineHeight: '160%',
      letterSpacing: '0.15px'
    },
    h7: {
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '166%',
      letterSpacing: '0px'
    },
    h8: {
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '100%',
      letterSpacing: '0px'
    },
    body1: {
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '150%',
      letterSpacing: '0px'
    },
    body2: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '143%',
      letterSpacing: '0px'
    },
    body3: {
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: 'normal',
      letterSpacing: '0px'
    },
    custom1: {
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '143%',
      letterSpacing: '0px'
    },
    custom2: {
      fontWeight: 500,
      fontSize: '11px',
      lineHeight: '11px'
    },
    label: {
      fontSize: '11px',
      fontWeight: 600,
      lineHeight: '14px'
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '175%',
      letterSpacing: '0.15px'
    },
    listSm: {
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '10px'
    },
    itemDense: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.17px'
    },
    tableHeader: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '24px',
      letterSpacing: '0.17px'
    },
    buttonSmall: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '22px',
      letterSpacing: '0.46px'
    }
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '11px',
          fontWeight: 600,
          lineHeight: '14px',
          '& ul': {
            margin: 0,
            paddingLeft: '20px',
            lineHeight: '14px'
          },
          '& li': {
            marginBottom: '4px',
            '&:last-child': {
              marginBottom: 0
            }
          }
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '150%',
          letterSpacing: '0.15px'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '12px',
          fontStyle: 'normal'
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none'
        }
      }
    }
  }
});

export default theme;
